/**
 * Legacy SVG icon components — kept for re-export from icons/index.
 * New gradient icons live in icons/GradientIcons.tsx.
 */

import type { CSSProperties } from 'react';

interface IconProps {
  size?: number;
  style?: CSSProperties;
}

export function SparkIcon({ size = 16, style }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, ...style }}>
      <path d="M8 2V6M8 10V14M2 8H6M10 8H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4.3 4.3L6.7 6.7M9.3 9.3L11.7 11.7M11.7 4.3L9.3 6.7M6.7 9.3L4.3 11.7" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
    </svg>
  );
}

export function WarnIcon({ size = 12, color = '#fbbf24', style }: IconProps & { color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, ...style }}>
      <path d="M8 2L14.5 13H1.5L8 2Z" stroke={color} strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M8 6V9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11" r=".8" fill={color} />
    </svg>
  );
}

export function HourglassIcon({ size = 12, style }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, ...style }}>
      <path d="M4 2H12M4 14H12M5 2C5 5 8 7 8 7C8 7 5 9 5 14M11 2C11 5 8 7 8 7C8 7 11 9 11 14" stroke="#fbbf24" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}

export function SettingsIcon({ size = 12, color = 'currentColor', style }: IconProps & { color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, ...style }}>
      <circle cx="8" cy="8" r="2.5" stroke={color} strokeWidth="1.2" />
      <path d="M8 2v1.5M8 12.5V14M14 8h-1.5M3.5 8H2M12.2 3.8l-1 1M4.8 11.2l-1 1M12.2 12.2l-1-1M4.8 4.8l-1-1" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}

export function SaveIcon({ size = 12, color = 'rgba(255,255,255,0.4)', style }: IconProps & { color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, ...style }}>
      <rect x="2" y="2" width="12" height="12" rx="2" stroke={color} strokeWidth="1.2" />
      <rect x="5" y="2" width="6" height="4" rx="1" stroke={color} strokeWidth="1.2" />
      <rect x="4" y="9" width="8" height="5" rx="1" stroke={color} strokeWidth="1.2" />
    </svg>
  );
}

export function ImagePlaceholderIcon({ size = 24, color = 'rgba(255,255,255,0.3)', style }: IconProps & { color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, ...style }}>
      <rect x="2" y="4" width="20" height="16" rx="2" stroke={color} strokeWidth="1.5" />
      <path d="M2 16L8 10L13 14L18 9L22 12" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="8" cy="8" r="2" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

export function CloseIcon({ size = 12, color = 'currentColor', style }: IconProps & { color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, ...style }}>
      <path d="M4 4L12 12M12 4L4 12" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function ProjectIcon({ size = 24, style }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, ...style }}>
      <path d="M2 4a1 1 0 011-1h3l2 2h4a1 1 0 011 1v6a1 1 0 01-1 1H2a1 1 0 01-1-1V4z" stroke="#7850ff" strokeWidth="1.2" fill="rgba(120,80,255,0.08)" />
    </svg>
  );
}

export function UserDevIcon({ size = 20, color = 'currentColor', style }: IconProps & { color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, ...style }}>
      <circle cx="12" cy="8" r="3" stroke={color} strokeWidth="1.5" />
      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
